// extracted by mini-css-extract-plugin
export default {"drop_zone":"DropZoneDiv_drop_zone__GTz3w"};